import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TimeBlock = ({ value, label }: { value: string; label: string }) => (
  <Box display="flex" flexDirection="column" alignItems="center" margin="0 0.5rem">
    <Typography style={{ fontSize: '1.5rem', fontWeight: 700 }} color="primary">
      {value}
    </Typography>
    <Typography style={{ fontSize: '1rem', fontWeight: 400 }} color="primary">
      {label}
    </Typography>
  </Box>
);

export default TimeBlock;
